<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>

            <h2 class="text-center pt2 pb-4">Расписание и стоимость</h2>

            <div class="mt-2">
                <b-card-group deck class="pb-4">
                        <b-table class="text-center"  responsive striped hover :items="items"></b-table>
                </b-card-group>
            </div>
        </div>

    </div>
</template>

<script>
import Cookies from "js-cookie";
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        items: [],
        storedStatusJW: false,
    }),
    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/timetable')
                .then(response => {
                    this.items = response.data;
                })
        } else {
            window.location.href = '/home';
        }
    },
    methods: {
        getDay(day) {
            return this.days[day];
        },
    },
    computed: {
        ...mapGetters([
            'storedStatusJWT'
        ])
    }
}
</script>
<style>
@media screen {
    .form_login {
        width: 300px;
    }
}

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}

.modal-backdrop {
    opacity: 0.5;
}
</style>
